// extracted by mini-css-extract-plugin
export var closeButton = "_bt-1";
export var closeX = "_bt-3";
export var container = "_bt-0";
export var image = "_bt-2";